import pickBy from "lodash/fp/pickBy";
import identity from "lodash/fp/identity";

const stripUndefined = pickBy(identity);

export default stripUndefined;
